import {ModuleConfiguration} from "../router/model/UserPermission";
import {UserServiceModuleName} from "../utils/names/optionalModuleNames";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";

export const UserServiceModuleConfiguration = new ModuleConfiguration(UserServiceModuleName, [
    AngularJsMaterialModuleName
]);